/**
 * THE document-upload limits, for BOTH platforms and every flow (deck
 * creation, attach-to-deck, quiz/oral/case source pickers). Web and mobile
 * each carried their own copies of these numbers; they live here so they
 * cannot drift.
 *
 * Keep in sync with user-facing copy: web `uploadDocumentLimit` /
 * `toast.pdf-file-too-big` (`*-generic.json`), mobile `create.pageLimitApplied`.
 */

/**
 * The document MIME types every uploader accepts (converted to PDF on the
 * backend when they are not one). `.pages` files are often reported as
 * `application/zip`; callers that see a zip must also check the extension.
 */
export const DOCUMENT_MIME_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.ms-powerpoint', // .ppt
  'text/plain', // .txt
  'application/vnd.apple.pages', // .pages
  'application/zip', // .pages files are often detected as zip
  'application/x-iwork-keynote-sffkey', // .key (Keynote)
] as const;

/** Extensions whose MIME type browsers/OSes report unreliably. */
export const DOCUMENT_SPECIAL_EXTENSIONS = ['.pages', '.key'] as const;

/** Max document upload size (PDF, DOCX, PPTX, TXT, Pages, Keynote). */
export const MAX_DOCUMENT_SIZE_MB = 100;
export const MAX_DOCUMENT_SIZE_BYTES = MAX_DOCUMENT_SIZE_MB * 1024 * 1024;

/**
 * Max PDF pages a single generation/attach may consume. Web enforces it in
 * the "Select pages" dialog; mobile's "Preparing PDF" step enforces it in
 * its own per-page grid on iOS, and on Android — which cannot render the PDF
 * preview — counts the pages with pdf-lib and auto-continues with the first
 * cap-worth of them.
 */
export const MAX_SELECTABLE_PDF_PAGES = 200;
